import { IApplicationState } from '../../types/redux';

export const selectCurrentRegionName = (state: IApplicationState): string => state.currentRegion.displayName;
